module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-footer-consumer-193e9c90de56f4123a6f7b9dbcd3468b.png";